<template>
  <CommonPages id="privacy-policy" :class="['resources-page']" titlePrefix="Privacy Policy"
    :metaDescription="domainConfig?.['meta']?.des || 'Privacy Policy'">

    <div class="resources-row">
      <div class="resources">
        <!-- 页面主标题 -->
        <h2 class="resources__title">Privacy Policy</h2>

        <h3 class="resources__subtitle">Your privacy is important to us at
          {{ domainConfig?.siteName }}. We are committed to protecting your information and ensuring
          a safe online experience.</h3>

        <h3 class="resources__subtitle">No Personal Data Collection</h3>
        <div class="resources__content">
          <p>
            We do not collect personal information or use cookies to track your activity.
          </p>
        </div>

        <h3 class="resources__subtitle">Third-Party Services</h3>
        <div class="resources__content">
          <p>
            We use Google Analytics and other third-party services to gather public data for
            analytical purposes. These services may collect information such as your IP address and
            browsing behavior.
          </p>
        </div>
        <h3 class="resources__subtitle">Data Security</h3>
        <div class="resources__content">
          <p>
            We take appropriate measures to protect your data and ensure it is used responsibly.
          </p>
        </div>
        <h3 class="resources__subtitle">Your Rights</h3>
        <div class="resources__content">
          <p>
            You have the right to access and control your data. For any inquiries, please contact us
            at {{ domainConfig?.IAMEMAIL }}.
          </p>
        </div>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'
import '@/css/resources.scss'

export default {
  name: 'PrivacyPolicy',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  }
}
</script> 